import {
  types,
  addDisposer,
  resolveIdentifier,
  tryReference,
  getParent,
  IMapType,
  IAnyType
} from 'mobx-state-tree'
import { ElementEdge } from 'src/api/models/Elements'

type ISimplePerception = { [key in string]: any }

type ISelectorPerception = {
  selector: string
} & {
  [key in string]: ISimplePerception
}

const DefaultPereception = types.frozen<ISelectorPerception | ISimplePerception>()

const PerceptionEntry = types.model({
  identifier: types.reference(types.late(ElementEdge), {
    onInvalidated: ({ parent }) => {
      getParent<IMapType<IAnyType>>(parent).delete(parent.identifier)
    }
  })
})

const Perception = types.union(PerceptionEntry, types.frozen())

export const PerceptionStore = types.model({
  perceptions: types.map(DefaultPereception)
})
